import React from 'react'

const PrimaryButton = ({ children, classes, handler }) => {
  return (
    <button
      onClick={handler}
      className={`text-white  bg-red-500  ${classes}`}
    >
      {children}
    </button>
  )
}

export default PrimaryButton
